export const name = 'gzImgSrc';

/**
 * @ngdoc directive
 * @name gazelle.components.printosImages.imgSrc.directive:gzImgSrc
 *
 * @param {string=} gzImgSrc path to an image in common printos-images
 *
 * @description
 * `gz-img-src` is an attribute directive for specifying an image src attribute
 * with an absolute URL to a common PrintOS images location.
 *
 * @usage
 * ```html
 * <img gz-img-src='logos/hp.png'></img>
 * ```
 * Produces
 * ```html
 * <img gz-img-src='logos/hp.png' src="https://www.printos.com/images/logos/hp.png"></img>
 * ```
 */
export default function gzImgSrc(rnRegistry) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    restrict: 'A',
    link: gzImgSrcLink,
  };

  return directive;

  //////////////////////

  function gzImgSrcLink(scope, element, attrs) {
    attrs.$observe(name, function(imgPath) {
      rnRegistry.getImageUrl(imgPath)
        .then(imgUrl => {
          element.attr('src', imgUrl);
        });
    });
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/printos-images/img-src/img-src.directive.js